import { writeUrlParam } from "./urlParams.js";

// Navigating out of a FULL-SCREEN detail panel drops it back to the normal
// two-column layout. The panel keeps its content — the reader is going to
// look at something else alongside the trace, not to be rid of it — and the
// collapse is the same command the panel's own control issues, so it is the
// same FLIP animation rather than one only navigation can produce.
//
// ORDER is the whole trick, and it is the reverse of the obvious one: the
// navigation runs FIRST, the collapse two frames later. The full-screen
// panel is opaque, so the new lens mounts invisibly behind it, and the
// collapse then reveals content that has already settled. Collapsing first
// (or simultaneously) revealed the focus column mid-swap — a visible
// flicker of the old lens tearing down while the panel shrank. Waiting on
// the collapse to navigate was worse still: the settle signal isn't
// guaranteed to arrive, and a deferred URL write can miss the param
// merger's coalescing window entirely (observed as the lens silently never
// changing).
//
// ContentShell ignores the command unless "detail" is the expanded column,
// so this never tears down a focus expand, and it is a no-op when nothing
// is expanded — the common case, which stays synchronous throughout.
//
// `clearReplayParam` is for navigations that REMOUNT the explorer subtree
// (a scope change): a shell that mounts with ?xcol=detail still set replays
// the full-screen lift over the new scope, so the param is cleared before
// the navigation runs — the remount then simply lands in the resting
// layout. The dispatch still covers any non-remounting path.
export function exitDetailFullScreen(navigate, { clearReplayParam = false } = {}) {
  if (clearReplayParam) writeUrlParam("xcol", null);
  navigate();
  requestAnimationFrame(() => requestAnimationFrame(() => {
    window.dispatchEvent(new CustomEvent("origin-column-expand", {
      detail: { columnId: "detail", mode: "collapse" },
    }));
  }));
}
